import { IChecklist } from '@core/entities/checklist/Checklist/IChecklist'
import { IPeriodicCheck } from '@core/entities/PeriodicCheck'
import { localizedStrings } from '@core/strings'

export type ChecklistPermittedActions =
  | 'READ'
  | 'LIST_AUDITS'
  | 'DOWNLOAD'
  | 'CLONE'
  | 'REMOVE_PARTICIPANT'
  | 'BRIEF_PARTICIPANTS'
  | 'LIST_COMMENTS'
  | 'COMMENT'
  | 'APPROVE'
  | 'REJECT'
  | 'REQUEST_CHANGES'
  | 'ADDRESS_REQUESTED_CHANGES'
  | 'NOMINATE_APPROVERS'

export type ChecklistResultType = {
  type: 'CHECKLIST' | 'PERIODIC_CHECK'
  checklist?: IChecklist
  periodicCheck?: IPeriodicCheck
  createdOn: string
}

export const ALL_CHECKLIST_STATUSES = [
  'COMPLETED',
  'AWAITING_APPROVAL',
  'CHANGES_REQUESTED',
  'REJECTED',
  'APPROVED',
] as const
type ChecklistTypeTuple = typeof ALL_CHECKLIST_STATUSES
export type ChecklistStatus = ChecklistTypeTuple[number]

export enum ChecklistListTabs {
  ALL_CHECKLISTS = 'All Checklists',
  MY_CHECKLISTS = 'My Checklists',
  DRAFTS = 'Drafts',
}

export enum InspectionListTabs {
  ALL_INSPECTIONS = 'All Inspections',
  MY_INSPECTIONS = 'My Inspections',
}

export type ChecklistInspectionStats = {
  inspectionItems: {
    byOutcome: {
      pass: number
      fail: number
      na: number
    }
    total: number
  }
  raisedTasks: {
    byPriority: {
      critical: number
      high: number
      medium: number
      low: number
    }
    total: number
  }
  unresolvedTasks?: {
    byPriority: {
      critical: number
      high: number
      medium: number
      low: number
    }
    total: number
  }
}

export type InspectionOutcome =
  keyof ChecklistInspectionStats['inspectionItems']['byOutcome']

export const inspectionOutcomeLabels: Record<InspectionOutcome, string> = {
  pass: localizedStrings.satisfactory,
  fail: localizedStrings.needsAttention,
  na: localizedStrings.na,
}
